import UserGroupNodeRenderer from "../../hierarchySelector/userSelector/UserGroupNodeRenderer";
import messageResource from "../../messageResource"
import {disableTextSelection} from '../../atBrowserUtils'

export default class UserGroupSelectableNodeRenderer extends UserGroupNodeRenderer {
    constructor(tree, selectorFilter, expandCollapseCallback, hideSelect) {
        super(tree, selectorFilter, expandCollapseCallback);
        this.hideSelect = hideSelect;
    }

    generateContent(treeNode, targetEl) {
        let tableEl = document.createElement("table");
        let tBodyEl = document.createElement("tbody");
        let trEl = document.createElement("tr");
        let titleTdEl = document.createElement("td");
        let selectTdEl = document.createElement("td");
        let collapseTdEl = document.createElement("td");

        let selectEl = this.generateSelect(treeNode);
        let normalExpandCollapseButton = this.generateExpandCollapseButton(treeNode, true, "normalExpandCollapseButton", null);
        let disabledExpandCollapseButtonWithTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithTitle",
            this.getExpandCollapseButtonTitle(treeNode));
        let disabledExpandCollapseButtonWithoutTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithoutTitle", null);

        tableEl.appendChild(tBodyEl);
        tBodyEl.appendChild(trEl);
        trEl.appendChild(titleTdEl)
        if (!this.hideSelect) {
            trEl.appendChild(selectTdEl);
        }
        trEl.appendChild(collapseTdEl);
        selectTdEl.appendChild(selectEl);
        collapseTdEl.appendChild(normalExpandCollapseButton);
        collapseTdEl.appendChild(disabledExpandCollapseButtonWithTitle);
        collapseTdEl.appendChild(disabledExpandCollapseButtonWithoutTitle);

        let spacerDiv = document.createElement("div");
        spacerDiv.className = "spacer";
        spacerDiv.innerHTML = "<b></b>"; // for IE to display correctly

        targetEl.appendChild(tableEl);
        targetEl.appendChild(spacerDiv);

        let titleNode = document.createElement("a");
        titleNode.className = "titleNode";
        titleNode.hidefocus = "true";

        disableTextSelection(titleNode);

        let labelEl = document.createElement("span");
        labelEl.className = "ellipsisLabel ellipsisSelectableLabel";
        this.generateLabel(treeNode, labelEl);

        titleTdEl.appendChild(titleNode);
        titleNode.appendChild(labelEl);

        this.tree.getUIObjectForNode(treeNode).cbEl = titleNode;
        this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
        this.tree.getUIObjectForNode(treeNode).selectEl = selectEl;
    }

    generateSelect(treeNode) {
        const selectEl = document.createElement("p");
        this.renderSelectContent(treeNode, selectEl);

        selectEl.className = "selectUserGroupElement";

        return selectEl;
    }

    renderSelectContent(treeNode, selectEl) {
        const selectionController = this.tree.getSelectionController();
        const showDeselectAll = selectionController.hasAllChildrenSelected(treeNode);
        const disabled = selectionController.hasAllChildrenDisabled(treeNode);

        selectEl.className = !disabled ? "selectUserGroupElement" : "selectUserGroupElement disabledSelectedUserGroupElement";

        selectEl.onclick = function() {
            showDeselectAll ? selectionController.deselectSubtree(treeNode) : selectionController.selectSubtree(treeNode, true);
        }

        selectEl.innerText = showDeselectAll ? messageResource.getMessage("assigned_users_editor.managers.task.users_deselect_group") : messageResource.getMessage("assigned_users_editor.managers.task.users_select_group");
    }

    updateUI(treeNode) {
        const uiObject = this.tree.getUIObjectForNode(treeNode)

        if (uiObject.selectEl) {
            this.renderSelectContent(treeNode, uiObject.selectEl);
        }

        super.updateUI(treeNode);
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/UserGroupSelectableNodeRenderer.js